import OwnerType from '../ownerType';
export default class Cooperative extends OwnerType {
  constructor() {
    super();
    this.id = 'cooperative';
    this.name = "Borettslag / Andelsbolig";
    this.icon = "mdi-account-group";
  }
}